import React from "react";
import {Divider, Grid, Header, Icon, Image, Segment, Table} from "semantic-ui-react";
import Bullet1 from "../images/Punkt1_95@4x.png";
import Bullet2 from "../images/Punkt2_96@4x.png";
import Bullet3 from "../images/Punkt3_97@4x.png";
import KlimaBanner from "../images/Grafik nyt design 13092021.svg";
import NestleLogo from "../images/nestle.png";
import AlibabaLogo from "../images/Alibaba_group_logo.png";
import RepublicLogo from "../images/Republic_Services_logo.png";
import "./Klima.css"

const Forside = props => (
    <div style={{backgroundColor: 'white'}}>
        <Header as="h2" textAlign="center">Godt nyt til dig, der ønsker at gøre noget ekstra for klimaet</Header>
        <Divider hidden/>
        <Segment basic>
            <p>Din pension er en vigtig brik, hvis du vil gøre noget ekstra for klimaet. Nu får du, som har en
                Letsikring af indtægt ved pension, endnu en mulighed: I
                løbet af 2021 er Letpension sammen med PFA klar med en ny opsparingsmulighed med ekstra fokus på
                klimavenlige investeringer.</p>
            <p>De klimavenlige investeringer har samme risikoniveau og forventning til afkast på langt sigt som din
                nuværende opsparing. Derfor skal du blot vælge, hvor stor en andel af din opsparing, der skal have
                ekstra
                fokus på klimaet.</p>

            <h3>Du kan mindske CO<sub>2</sub>-aftrykket med din pension</h3>
            <p>Du kan mindske dit CO<sub>2</sub>-aftryk på mange måder. Du kan spise mindre kød, du kan flyve mindre, du
                kan skifte
                benzinbilen ud med en elbil. Men du kan også påvirke det store CO<sub>2</sub>-regnskab med din pension.
                For hver
                100.000 kr. du lægger i ekstra klimavenlige investeringer, sparer du miljøet for 0,89 Ton
                CO<sub>2</sub> hvert år. En kødfri dag om ugen i et helt år svarer til en besparelse på 95 kg
                CO<sub>2</sub>. Det kan altså hurtigt blive til meget, hvis du flytter en del af din pension til ekstra
                klimavenlige investeringer. (Kilde: PFA, beregning af 30.06.2021)</p>
            <p><a href="https://pfa.dk/andet/disclaimer-klimaplus/" target="_blank" rel="noopener noreferrer"
                  className="link">Sådan beregner PFA
                CO<sub>2</sub></a></p>
        </Segment>
        <Divider hidden/>
        <Segment basic style={{backgroundColor: '#f6f0e7'}}>
            <h3>Tre ambitiøse klimamål</h3>
            <p>Når PFA investerer, er det altid med tanke på ansvarlighed, bæredygtighed og med udgangspunkt i
                Paris-aftalen
                og FN’s Verdensmål ud fra principperne om ansvarlige investeringer – uanset hvilken opsparing du
                vælger. </p>
            <p>Med ekstra klimavenlige investeringer bidrager din opsparing desuden til tre ambitiøse klimamål:</p>

            <Grid centered stackable columns="three" divided>
                <Grid.Row>
                    <Grid.Column style={{textAlign: 'center'}}>
                        <div><img src={Bullet1} className="bullet"/></div>
                        <div><b>Aktiedelen skal allerede nu som minimum udlede 60 % mindre CO<sub>2</sub> end
                            verdensaktieindekset*</b>
                        </div>
                    </Grid.Column>
                    <Grid.Column style={{textAlign: 'center'}}>
                        <div><img src={Bullet2} className="bullet"/></div>
                        <div><b>Frem mod 2025 er ambitionen, at hele produktet skal være CO<sub>2</sub> neutralt**.</b>
                        </div>
                    </Grid.Column>
                    <Grid.Column style={{textAlign: 'center'}}>
                        <div><img src={Bullet3} className="bullet"/></div>
                        <div><b>Frem mod 2030 er ambitionen, at hele produktet skal være CO<sub>2</sub> negativt**, og
                            dermed
                            trække mere CO<sub>2</sub> ud af atmosfæren, end det udleder.</b>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <p style={{fontStyle: 'italic', fontSize: 13}}>* MSCI All Countries World Index.<br/>** Søges opfyldt gennem
                investering i skov og teknologi, der tager CO<sub>2</sub> ud af atmosfæren</p>
        </Segment>

        <Divider hidden/>

        <Segment basic>
            <p>PFA måler løbende CO<sub>2</sub>-udledningen på alle investeringer i aktier og sammenligner med
                verdensaktieindekset. Som illustrationen viser, udleder aktierne i de mere klimavenlige investeringer 80
                % mindre CO<sub>2</sub> end verdensaktieindekset (MSCI), mens alle PFA's aktieinvesteringer pt. udleder 19 % mindre CO<sub>2</sub> (opdateret 31.08.2021).</p>

            <Grid centered stackable columns="one" divided>
                <Grid.Row>
                    <Grid.Column style={{textAlign: 'center'}}>
                        <div><Image src={KlimaBanner}/></div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>

        <Segment basic style={{backgroundColor: '#f6f0e7'}}>
            <h3>Et bedre klima er vi fælles om</h3>
            <p>Investeringer med ekstra fokus på klima kan være vindmøller og solenergi, men også meget andet. Mange
                virksomheder i stort set alle brancher har fokus på deres klimaaftryk, og det arbejder de med på
                forskellige
                måder. PFA investerer både i virksomheder og projekter. Se et udpluk af de investeringer, der har et
                ekstra
                fokus på klima:</p>
            <Grid centered stackable columns="three" divided>
                <Grid.Row>
                    <Grid.Column style={{textAlign: 'center'}}>
                        <div><img src={RepublicLogo} className="klima-logo"/></div>
                        <div>Republic Services Inc. er det amerikanske renovationsselskab, der er længst fremme i den
                            grønne
                            omstilling, når det gælder om at genbruge affald eller omdanne det til energi. Selskabet
                            håndterer ikke-farligt affald fra private og virksomheder, og de har fokus på miljøvenlig
                            håndtering og skånsom transport. Derfor kører deres biler i stigende grad på naturgas og
                            ikke
                            benzin.
                        </div>
                    </Grid.Column>
                    <Grid.Column style={{textAlign: 'center'}}>
                        <div><img src={NestleLogo} className="klima-logo"/></div>
                        <div>Nestlé er verdens største fødevareselskab med kendte brands som bl.a. Kitkat, Perrier, San
                            Pellegrino, Vittel og Nescafé. Nestlé har forpligtet sig til nuludledning af drivhusgasser i
                            2050 på linje med Paris-aftalen, og 41 % af el-forbruget er i dag vedvarende energi.
                            Derudover
                            har Nestlé sat som mål at gøre 100 % af alt plastikemballage genanvendeligt i 2025 og bruge
                            mindre plastik generelt.
                        </div>
                    </Grid.Column>
                    <Grid.Column style={{textAlign: 'center'}}>
                        <div><img src={AlibabaLogo} className="klima-logo"/></div>
                        <div>Alibaba er et kinesisk internet-konglomerat, der blandt andet ejer e-handelsplatforme og
                            udbyder it- og cloudløsninger. Alibaba er drevet med klimavenlige initiativer, hvor et
                            datacenter fx køles med vand fra en sø, og et andet bruger sol- og vindenergi. Samtidig
                            sparer
                            Alibaba rigtig meget strøm med deres it-løsninger, fordi det er mere energieffektivt, end
                            hvis
                            kunderne havde hver deres løsning.
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>

        <Divider hidden/>

        <Segment basic>
            <h3>Sammenligning af opsparingsmuligheder</h3>
            <p>Opsparing med ekstra fokus på klima skal ikke koste på forventningerne til afkastet. Derfor er
                risikoniveauet
                og forventninger til afkast på langt sigt de samme, selvom du vælger at flytte en del af din opsparing
                dertil. Dog vil afkastet udvikle sig forskelligt, fordi produkterne er investeret forskelligt.</p>
            <p>Mange af investeringerne med ekstra fokus på klima indgår i de øvrige investeringer, men ikke
                nødvendigvis
                omvendt. Det skyldes de ekstra høje krav, som kun få selskaber kan leve op til. At der investeres i
                færre
                selskaber, kan give større udsving i afkastet især på den korte bane. På den lange bane betyder det
                forventeligt mindre, og pension er en langsigtet opsparing.</p>

            <Table color="teal" inverted celled unstackable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Parametre</Table.HeaderCell>
                        <Table.HeaderCell>Investering i Letsikring</Table.HeaderCell>
                        <Table.HeaderCell>Investering i Letsikring med ekstra fokus på klima</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row>
                        <Table.Cell>Politik for ansvarlige investeringer og aktivt ejerskab</Table.Cell>
                        <Table.Cell><Icon name="checkmark"/></Table.Cell>
                        <Table.Cell><Icon name="checkmark"/></Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Ekstra klimafokus</Table.Cell>
                        <Table.Cell></Table.Cell>
                        <Table.Cell><Icon name="checkmark"/></Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Eksklusion af fossile brændstoffer</Table.Cell>
                        <Table.Cell></Table.Cell>
                        <Table.Cell><Icon name="checkmark"/></Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>CO<sub>2</sub> emission ift. Verdensaktieindekset</Table.Cell>
                        <Table.Cell>-16 %</Table.Cell>
                        <Table.Cell>-80 %</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Målsætning om CO<sub>2</sub> neutral i år</Table.Cell>
                        <Table.Cell>2050</Table.Cell>
                        <Table.Cell>2025</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Alternative investeringer og ejendomme</Table.Cell>
                        <Table.Cell>Ca. 23 % pt</Table.Cell>
                        <Table.Cell>Ca. 20 % over tid</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Risiko</Table.Cell>
                        <Table.Cell colSpan={2} textAlign="center">Sammenlignelig risiko*</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Forventet afkast </Table.Cell>
                        <Table.Cell colSpan={2} textAlign="center">Samme forventede langsigtede afkast**</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>ÅOP</Table.Cell>
                        <Table.Cell>0,33-0,78 %</Table.Cell>
                        <Table.Cell>0,33-0,78 %</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Nedtrapning af risiko frem mod pension</Table.Cell>
                        <Table.Cell><Icon name="checkmark"/></Table.Cell>
                        <Table.Cell><Icon name="checkmark"/></Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>

            <p style={{fontStyle: 'italic', fontSize: 13}}>
                * Aktieporteføljen, der har ekstra fokus på klima, består af færre aktier (ca. 50) og har et bærende
                tema
                om reduceret klimapåvirkning. Det betyder, at koncentrationsrisikoen er større. Samtidig er der en
                såkaldt
                scenarierisiko, hvis fx det politiske og forretningsmæssige klimafokus skifter markant ift. det
                nuværende.
                På langt sigt er risikoen dog overordnet set den samme.<br/>
                ** Det faktiske afkast vil udvikle sig forskelligt, da investeringerne er forskellige. Det er kun
                forventningerne til det langsigtede afkast, der er de samme.
            </p>
        </Segment>

        <Divider hidden/>

        <Segment basic style={{backgroundColor: '#f6f0e7'}}>
            <h3>Derfor kan din pension gøre en forskel</h3>
            <p>Sammenlagt har danskerne sparet mange milliarder op i deres pensioner. Netop derfor har pensionsselskaber
                en
                vigtig rolle, når det kommer til at påvirke samfund og virksomheder i en mere klimavenlig retning. PFA
                forvalter ca. 585 milliarder kr. (opgjort med udgangen af dec. 2020) og kan derfor opnå stor
                indflydelse.
                PFA
                har indflydelse i kraft af de selskaber, de vælger at investere i, hvor PFA bl.a. på generalforsamlinger
                påvirker selskaberne. </p>
        </Segment>

    </div>
);

export default Forside;
